import { useEffect, useState } from 'react';

export const MOBILE_VIEW_PREFERENCE_KEY = 'realairschedule-mobile-view';
const mobileViewPreferenceEvent = 'realairschedule-mobile-view-change';

export const isMobileDevice = () => {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '')
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

export const getIsMobileView = () => {
  try {
    const preference = localStorage.getItem(MOBILE_VIEW_PREFERENCE_KEY);
    if (preference === 'mobile') return true;
    if (preference === 'desktop') return false;
  } catch { /* Use device detection when storage is unavailable. */ }
  return isMobileDevice();
};

export const setMobileViewPreference = preference => {
  try { localStorage.setItem(MOBILE_VIEW_PREFERENCE_KEY, preference); } catch { /* Keep the current view for this session. */ }
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(mobileViewPreferenceEvent));
};

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(getIsMobileView);
  useEffect(() => {
    const update = () => {
      const mobile = getIsMobileView();
      document.documentElement.classList.toggle('mobile-device', mobile);
      setIsMobile(mobile);
    };
    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    window.addEventListener(mobileViewPreferenceEvent, update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
      window.removeEventListener(mobileViewPreferenceEvent, update);
    };
  }, []);
  return isMobile;
};